"use client";

import { FieldAttributes, useField } from "formik";
import type { DetailedHTMLProps, InputHTMLAttributes } from "react";

import Checkbox from "@ui/js/components/form/checkbox";

type Props = FieldAttributes<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> & {
  label: string;
};

export default function FormikCheckbox({ label, ...props }: Props) {
  const [field, meta] = useField(props);

  return (
    <Checkbox
      label={label}
      {...field}
      {...props}
      checked={(meta.value as string[]).indexOf(props.value) >= 0}
    />
  );
}
